/* eslint semi:0 */
import { path } from '../utils/ua'
import { isString } from '../utils/string'
import { queryString } from '../utils/window'
import { safeRequest } from '../utils/mithril'
const { info } = require('../application/console')
import { registerInNamespace } from '../application/nm'
import { create as makeEmptyObj } from '../utils/object'
import safeLocalStorage from './safeLocalStorageProvider'

const GEOLOCATION_API_ENDPOINT = '//geoip.90min.com'
const GEOLOCATION_STORAGE_KEY = 'NM_GEOLOCATION'

export const COUNTRIES_IN_EUROPE = [
  'AU',
  'IT',
  'BE',
  'LV',
  'BG',
  'LT',
  'HR',
  'LU',
  'CY',
  'MT',
  'CZ',
  'NL',
  'DK',
  'PL',
  'EE',
  'PT',
  'FI',
  'RO',
  'FR',
  'SK',
  'DE',
  'SI',
  'GR',
  'ES',
  'HU',
  'SE',
  'IE',
  'GB',
]

let countryCodeQsOverride = queryString.countryCode
// I used an empty string (instead of null) to avoid checking for !== null
// each time you'll want to use String class methods on it.
export const NO_LOCATION = 'no-location'
const QS_DELETE_COUNTRY_CODE = 'delete'

let countryCodePromise = null

const isDeleteCountryCodeQs = countryCodeQsOverride === QS_DELETE_COUNTRY_CODE

function getCountryCodeFromQsOverride() {
  let override
  if (countryCodeQsOverride && isString(countryCodeQsOverride) && !isDeleteCountryCodeQs) {
    override = countryCodeQsOverride.toUpperCase()
    info(`[QS] overriding countryCode with '${countryCodeQsOverride}'`)
  }
  return override
}

function getCountryCodeFromLocalStorage() {
  return safeLocalStorage.get(GEOLOCATION_STORAGE_KEY)
}

let currentCountryCode = getCountryCodeFromQsOverride() || getCountryCodeFromLocalStorage()

export function getLastKnownCountryCode() {
  return currentCountryCode || NO_LOCATION
}

function cacheCurrentCountryCode(countryCode) {
  currentCountryCode = countryCode
  safeLocalStorage.set(GEOLOCATION_STORAGE_KEY, countryCode)
}

function getCountryCodeFromApi() {
  return safeRequest({
    method: 'GET',
    url: GEOLOCATION_API_ENDPOINT,
  })
}

function deleteCountryCode() {
  currentCountryCode = NO_LOCATION
  safeLocalStorage.remove(GEOLOCATION_STORAGE_KEY)
  countryCodePromise = null
}

if (isDeleteCountryCodeQs) {
  info(`[QS] deleting current countryCode`)
  deleteCountryCode()
}

export function getCountryCode() {
  return (
    countryCodePromise ||
    (countryCodePromise = new Promise(function getCountryCodePromise(resolve, reject) {
      if (currentCountryCode) {
        return resolve(currentCountryCode)
      }
      getCountryCodeFromApi().then(function cacheCountryCodeAndResolve({ countryCode }) {
        cacheCurrentCountryCode(countryCode)
        resolve(countryCode)
      }, reject)
    }))
  )
}

function refreshCountryCode() {
  deleteCountryCode()
  return getCountryCode()
}

const countryCodeProvider = Object.assign(makeEmptyObj(), {
  getCountryCode,
  get currentCountryCode() {
    return getLastKnownCountryCode()
  },
  delete: deleteCountryCode,
  refresh: refreshCountryCode,
  NO_LOCATION,
})

registerInNamespace({ countryCodeProvider })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/geolocationProvider.js